import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  Observable,
  Subject,
  combineLatestWith,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { StateService } from 'src/app/auth/state.service';
import { ApiOrganization } from 'src/app/models_new/classes/api-models/ApiOrganization';
import { IApiPattern } from 'src/app/models_new/classes/api-models/ApiPattern';
import { PatternApiService } from 'src/app/services/api/pattern-api.service';
import { ITableData } from '../../gui/table/table.component';
import { DataRequestState } from 'src/app/data-request/model';
import { toRequestState } from 'src/app/data-request/operators';
import {
  FilterTableData,
  ISortingOption,
} from 'src/app/models_new/types/sorting-option';
import { IFilterData } from 'src/app/models_new/types/filter-data';
import { SortDirection } from '@angular/material/sort';
import { ObjectUtils } from 'src/app/utils/object';
import { PickerType } from 'src/app/models_new/enums/picker-type';
import { determinePalletType as determinePalletTypeImported } from 'src/app/utils/patterns-utils';
import { ListOfAllPallets } from 'src/app/models_new/config/form_fields';
import { IStandardPallet } from 'src/app/models_new/types/standard-pallet';
import { ActivatedRoute, Router } from '@angular/router';
import { IApiRobotConfiguration } from 'src/app/models_new/classes/api-models/ApiRobotConfiguration';
import { RobotConfigApiService } from 'src/app/services/api/robot-config-api.service';
import { SupportWidgetService } from 'src/app/services/support-widget.service';
import { SelectionModel } from '@angular/cdk/collections';
import { DialogService } from 'src/app/services/dialog.service';
import { NewSimpleSimulationComponent } from '../../dialogs/new-simple-simulation/new-simple-simulation.component';
import { DialogSize } from 'src/app/models_new/enums/dialogSize';
import { SimulationStatus } from 'src/app/models_new/enums/simulation-status';
import { SimulationApiService } from 'src/app/services/api/simulation-api.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { pagesPATH } from 'src/app/models_new/config/pages';
import { LocalStorageKey } from 'src/app/models_new/enums/local-storage-keys';
import { LocalStorageService } from 'src/app/services/local-storage.service';

type SelectPatternActions = 'delete';

@Component({
  selector: 'app-installed-robot-simulation-wizard',
  templateUrl: './installed-robot-simulation-wizard.component.html',
  styleUrls: ['./installed-robot-simulation-wizard.component.scss'],
})
export class InstalledRobotSimulationWizardComponent
  implements OnInit, OnDestroy
{
  objUtil = ObjectUtils;

  robotConfig$: Observable<DataRequestState<IApiRobotConfiguration>>;
  robotConfig: IApiRobotConfiguration;
  patternTableData$: Observable<
    DataRequestState<ITableData<SelectPatternActions>[]>
  >;
  patterns: IApiPattern[];

  pickerType: PickerType = PickerType.PATTERN;
  cardColumns: string[] = ['name'];
  patternsSelected = new SelectionModel<ITableData['data']>(true, []);

  selectedPatternsTitle: string = this.getSelectedPatternsTitle(
    this.patternsSelected.selected
  );

  displayedColumns: string[] = [
    'select',
    'name',
    'product_name',
    'product_dimensions',
    'cpm',
    'pallet_type',
    'total_height',
  ];

  cardDetailsData: any = [
    { name: 'Name', key: 'name' },
    { name: 'Product name', key: 'product_name' },
    { name: 'Product dimensions', key: 'product_dimensions' },
    { name: 'Pallet type', key: 'pallet_type' },
    { name: 'Box count', key: 'box_count' },
    { name: 'Number of layers', key: 'number_of_layers' },
    { name: 'Total height', key: 'total_height' },
    { name: 'Pallet weight', key: 'pallet_weight' },
    { name: 'CPM', key: 'cpm' },
  ];

  //
  // TODO: Filtering and sorting does not work for this and several similar components.
  // Separate task will be created to fix this and re-enable codebelow
  //

  sortingColumns: ISortingOption[] = [
    // {
    //   id: 'name',
    //   label: 'Name',
    // },
    // {
    //   id: 'product',
    //   label: 'Product',
    // },
    // {
    //   id: 'product_dim',
    //   label: 'Product dimentions (DxWxH)',
    // },
    // {
    //   id: 'cpm',
    //   label: 'CPM',
    // },
    // {
    //   id: 'pallet_type',
    //   label: 'Pallet type',
    // },
    // {
    //   id: 'total_height',
    //   label: 'Total Height',
    // },
  ];

  setupFilter: ISortingOption[] = [
    // {
    //   id: 'product.name',
    //   label: 'Products',
    //   children: [],
    // },
  ];

  resultFilter: IFilterData[] = [
    // {
    //   filterType: FilterType.SLIDER,
    //   id: 'product_amount',
    //   label: 'Product Amount',
    //   value: 0,
    //   min: 0,
    //   max: 1000,
    // },
    // {
    //   filterType: FilterType.SLIDER,
    //   id: 'total_height',
    //   label: 'Total Height',
    //   value: 0,
    //   min: 0,
    //   max: 3000,
    // },
  ];

  tableFilter: FilterTableData = new FilterTableData();
  orderBy: { column: string; order: SortDirection };

  destroy$ = new Subject<undefined>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private patternApi: PatternApiService,
    private robotConfigApi: RobotConfigApiService,
    private stateService: StateService,
    private supportWidgetService: SupportWidgetService,
    private dialogService: DialogService,
    private simulationApi: SimulationApiService,
    private errorHandler: ErrorHandlerService,
    private localStorageService: LocalStorageService
  ) {
    this.patternsSelected.changed
      .pipe(
        takeUntil(this.destroy$),
        map(() => {
          this.selectedPatternsTitle = this.getSelectedPatternsTitle(
            this.patternsSelected.selected
          );
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.supportWidgetService.resetSupportButtonStyling();
  }

  ngOnInit(): void {
    this.supportWidgetService.elevateSupportButton();

    this.robotConfig$ = this.robotConfigApi
      .fetchRobotconfigByID(this.route.snapshot.params?.id)
      .pipe(
        tap((rconfig) => (this.robotConfig = rconfig)),
        toRequestState()
      );

    this.patternTableData$ = this.stateService
      .getCustomerOrSalesOrganization()
      .pipe(
        map((org: ApiOrganization) => org.id),
        switchMap((orgId: string) =>
          this.patternApi.fetchSimWizPatterns(orgId)
        ),
        map((patterns) => {
          this.patterns = patterns;
          let tableData: ITableData<SelectPatternActions>[] = [];
          for (let pattern of patterns) {
            tableData.push({
              data: {
                id: pattern.id,
                name: pattern.name,
                cpm: pattern.data?.cpm,
                product_name: pattern.product.name,
                product_dimensions: this.productDimensions(
                  pattern.data.productDimensions
                ),
                pallet_type: this.determinePalletType(
                  pattern.data.dimensions,
                  ListOfAllPallets
                ),
                total_height:
                  pattern.data.dimensions.height +
                  pattern.data.dimensions.palletHeight +
                  ' mm',
                pattern: pattern,
                updated_at: pattern?.updated_at,
              },
            });
          }
          return tableData;
        }),
        toRequestState(),
        takeUntil(this.destroy$)
      );
  }

  getSelectedPatternsTitle(selectedPatterns: ITableData['data'][]): string {
    if (selectedPatterns.length === 1) {
      return selectedPatterns[0]?.name;
    } else if (selectedPatterns.length > 1) {
      return selectedPatterns.length + ' patterns selected';
    } else {
      return 'No pattern selected';
    }
  }

  patternRowClicked(e: ITableData['data']) {
    this.patternsSelected.toggle(e);
  }

  determinePalletType(dims: any, pallets: IStandardPallet[]): string {
    const palletType: string = determinePalletTypeImported(dims, pallets);

    if (palletType === 'Custom') {
      return (
        palletType +
        ' (' +
        dims.length +
        ' x ' +
        dims.width +
        ' x ' +
        dims.palletHeight +
        ' mm)'
      );
    } else {
      return palletType;
    }
  }

  productDimensions(dimensions: any): string {
    return (
      dimensions?.width +
      ' x ' +
      dimensions?.length +
      ' x ' +
      dimensions?.height +
      ' mm'
    );
  }

  destroy() {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  selectedPatterns() {
    return this.patterns.filter((pattern) =>
      this.patternsSelected.selected.find(
        (selectedpattern) => selectedpattern.id === pattern.id
      )
    );
  }

  goBack() {
    this.destroy();
    this.router.navigate([pagesPATH.INSTALLED_ROBOTS]);
  }

  startSimulation() {
    const dialogRef = this.dialogService.showCustomDialog(
      NewSimpleSimulationComponent,
      DialogSize.SMALL,
      null,
      {
        simulation: {
          name: '',
        },
      }
    );

    const createSim$ = this.stateService.getCustomerOrSalesOrganization().pipe(
      take(1),
      map((org: ApiOrganization) => org.id),
      combineLatestWith(dialogRef.afterClosed()),
      switchMap(([orgId, sim_name]) => {
        if (!sim_name) {
          throw 'cancel';
        }
        if (sim_name[0].name && !sim_name[0].value) {
          throw new Error('Simulation name is required!');
        }
        const simulations = [];
        for (let pattern of this.selectedPatterns()) {
          simulations.push({
            name: `${sim_name[0].value} - ${pattern.name} - ${
              simulations.length + 1
            }`,
            pattern_id: pattern.id,
            scene_id: this.robotConfig.scene.id,
            strategy_id: this.robotConfig.strategy.id,
            simulation_state: SimulationStatus.QUEUED,
            metadata: {
              unitSystem:
                this.localStorageService.getData(
                  LocalStorageKey.PREFERRED_UNIT_SYSTEM
                ) || 'metric',
            },
          });
        }
        return this.simulationApi.insertSimulationBatch(simulations, orgId);
      }),
      take(1)
    );

    createSim$.subscribe({
      next: () => {
        this.destroy();
        this.router.navigate([pagesPATH.SIMULATIONS]);
      },
      error: (err) => {
        if (err !== 'cancel') {
          this.errorHandler.handleError(err);
        }
      },
    });
  }
}
